import { Component } from '@angular/core';
import { LoaderService } from './loader.service';
import { LoaderModel } from './loader.model';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
    standalone: false
})
export class LoaderComponent {

  showLoader: boolean = false;
  constructor(private loaderService: LoaderService) {
    this.loaderService.loaderObserver.subscribe((loaderModel: LoaderModel) => {
      this.showLoader = loaderModel.isLoading;
    });
  }

 

}
